import React from 'react';

/**
 * To workaround the problem that `aria-hidden` is appended to the root container.
 * @see https://github.com/mui/material-ui/issues/19450#issuecomment-1539832475
 * @returns
 */
export function RootAriaLabelMuiBugFix(): null {
  const root = document.querySelector('#root');

  React.useEffect(() => {
    if (!root) {
      console.error("RootAriaLabelMuiBugFix couldn't find the element.");
      return;
    }

    const observer = new MutationObserver(() => {
      if (root.getAttribute('aria-hidden')) {
        root.removeAttribute('aria-hidden');
      }
    });

    observer.observe(root, {
      attributeFilter: ['aria-hidden'],
    });

    return () => {
      observer.disconnect();
    };
  }, [root]);

  return null;
}
